// removed by extract-text-webpack-plugin
module.exports = {"hero-wrapper":"HomePage__hero-wrapper___1rVea","hero":"HomePage__hero___d4lH0","intro-wrapper":"HomePage__intro-wrapper___3zt3o","ukraine":"HomePage__ukraine___15Rh8","announcement":"HomePage__announcement___2mE6V","separator-wrapper":"HomePage__separator-wrapper___3MK8I","nav":"HomePage__nav___2j918"};


//////////////////
// WEBPACK FOOTER
// ./application/js/pages/HomePage.css
// module id = 528
// module chunks = 0